import { render } from "./TokenizeJourneyForm.vue?vue&type=template&id=b964ab72&scoped=true"
import script from "./TokenizeJourneyForm.vue?vue&type=script&lang=js"
export * from "./TokenizeJourneyForm.vue?vue&type=script&lang=js"

import "./TokenizeJourneyForm.vue?vue&type=style&index=0&id=b964ab72&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b964ab72"]])

export default __exports__